import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { verifyAppointment } from '../services/appointmentService';
import '../styles/PatientCheckIn.css';

const PatientCheckIn = () => {
  const [identifier, setIdentifier] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-refresh error message after 30 seconds
    if (error) {
      const timer = setTimeout(() => {
        setError('');
      }, 30000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const result = await verifyAppointment(identifier);
      if (result.success) {
        // Handle successful check-in
        navigate('/check-in-success', { state: { appointment: result.appointment } });
      } else {
        setError('No scheduled appointment found within the next hour. Please consult with the front desk.');
      }
    } catch (err) {
      setError('No scheduled appointment found within the next hour. Please consult with the front desk.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="patient-checkin-container">
      <div className="checkin-form-wrapper">
        <h1>Welcome to Patient Check-In</h1>
        <p>Please enter your email address or phone number to check in</p>
        
        <form onSubmit={handleSubmit} className="checkin-form">
          <input
            type="text"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="Enter email or phone number"
            required
            className="checkin-input"
          />
          <button 
            type="submit" 
            disabled={isLoading}
            className="checkin-button"
          >
            {isLoading ? 'Checking...' : 'Check In'}
          </button>
        </form>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientCheckIn; 